import { LeadCardHistory } from 'modules/lead';
import { useObjectCard } from "../context/ObjectCardProvider";

const ObjectTabEvents = () => { 

    const { vObject, fetchObject } = useObjectCard();
    
    return (<div className="px-3"> 
        <LeadCardHistory
            fetchLead={fetchObject}
            lead={vObject?.lead} 
            events={vObject?.events}/>      
    </div>)
}
 
export default ObjectTabEvents;